/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_Seller_Hasnt_Added_ExclusInputs */

const en_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The seller hasn't added exclusive content yet. Check back soon or contact them directly.`)
};

const es_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El vendedor aún no ha agregado contenido exclusivo. Vuelve a consultar pronto o contáctalo directamente.`)
};

const fr_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le vendeur n'a pas encore ajouté de contenu exclusif. Revenez bientôt ou contactez-le directement.`)
};

const de_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Verkäufer hat noch keine exklusiven Inhalte hinzugefügt. Schau bald wieder vorbei oder kontaktiere ihn direkt.`)
};

const ja_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品者はまだ限定コンテンツを追加していません。後でもう一度確認するか、直接お問い合わせください。`)
};

const zh_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家尚未添加专属内容。请稍后查看或直接联系他们。`)
};

const ar_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يضف البائع محتوى حصرياً بعد. تحقق قريباً أو اتصل به مباشرة.`)
};

const id_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual belum menambahkan konten eksklusif. Periksa kembali nanti atau hubungi mereka secara langsung.`)
};

const it_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il venditore non ha ancora aggiunto contenuti esclusivi. Riprova più tardi o contattalo direttamente.`)
};

const ru_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец еще не добавил эксклюзивный контент. Загляните сюда позже или свяжитесь с ним напрямую.`)
};

const pt_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O vendedor ainda não adicionou conteúdo exclusivo. Verifique novamente em breve ou entre em contato diretamente com ele.`)
};

const ko_the_seller_hasnt_added_exclus = /** @type {(inputs: The_Seller_Hasnt_Added_ExclusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자가 아직 독점 콘텐츠를 추가하지 않았습니다. 나중에 다시 확인하거나 직접 문의해 보세요.`)
};

/**
* | output |
* | --- |
* | "The seller hasn't added exclusive content yet. Check back soon or contact them directly." |
*
* @param {The_Seller_Hasnt_Added_ExclusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_seller_hasnt_added_exclus = /** @type {((inputs?: The_Seller_Hasnt_Added_ExclusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_Seller_Hasnt_Added_ExclusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_seller_hasnt_added_exclus(inputs)
	if (locale === "es") return es_the_seller_hasnt_added_exclus(inputs)
	if (locale === "fr") return fr_the_seller_hasnt_added_exclus(inputs)
	if (locale === "de") return de_the_seller_hasnt_added_exclus(inputs)
	if (locale === "ja") return ja_the_seller_hasnt_added_exclus(inputs)
	if (locale === "zh") return zh_the_seller_hasnt_added_exclus(inputs)
	if (locale === "ar") return ar_the_seller_hasnt_added_exclus(inputs)
	if (locale === "id") return id_the_seller_hasnt_added_exclus(inputs)
	if (locale === "it") return it_the_seller_hasnt_added_exclus(inputs)
	if (locale === "ru") return ru_the_seller_hasnt_added_exclus(inputs)
	if (locale === "pt") return pt_the_seller_hasnt_added_exclus(inputs)
	return ko_the_seller_hasnt_added_exclus(inputs)
});